module.exports = __webpack_public_path__ + "static/media/img_high_potential_01.f57a409f.png";